<template>
  <div class="word-list1">
    <div
      class="head"
      :style="{
        backgroundImage: 'url(' + dataInfo.cover + ')'
      }"
    >
      {{ dataInfo.name }}
    </div>
    <div class="g-box">
      <div class="content">
        <div class="main">
          <div
            class="item"
            @click="toDetail(item)"
            v-for="item in list"
            :key="item.id"
          >
            <div class="top">
              <img :src="item.image" :alt="item.title" class="img" />
            </div>
            <div class="bottom">
              <div class="title">{{ item.title }}</div>
              <div class="subtitle">
                {{ item.subtitle }}
              </div>
              <div class="time">
                <div class="txt">{{ item.publishTime }}</div>
                <div class="more">查看详情 ></div>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          v-if="total > 9"
          @current-change="onCurrentChange"
          background
          layout="prev, pager, next"
          :current-page="pageNum"
          :page-size="pageSize"
          :total="total"
          class="m-pagination"
        />
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";

export default {
  data() {
    return {
      query: this.$route.query,
      params: {},
      dataInfo: {},
      pageSize: 9,
      dataList: []
    };
  },
  mixins: [pageMain_mx],
  components: {},
  mounted() {},
  methods: {
    async init() {
      this.params = this.$route.params;
      this.pageNum = 1;
      this.getAjax();
      const dataInfo = await this.getMenuInfo(this.params.menuId);
      this.dataInfo = dataInfo;
    },
    getAjax() {
      this.getList2();
    },
    toDetail(item) {
      this.$router.push("/article_details/" + item.id);
      console.log(item, "itemmm");
    }
  }
};
</script>
<style lang="less">
.word-list1 {
  .head {
    height: 280px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 60px;
    color: #fff;
    letter-spacing: 40px;
  }
  .content {
    padding-top: 60px;
    padding-bottom: 120px;
    .main {
      display: flex;
      flex-wrap: wrap;
      .item {
        margin-bottom: 20px;
        margin-right: 20px;
        width: 386px;
        background: #fff;
        box-shadow: 0px 5px 10px 0px rgba(15, 83, 255, 0.06);
        box-sizing: border-box;
        .top {
          width: 386px;
          height: 220px;
          border-radius: 4px;
          background: #999;
          .img {
            display: block;
            width: 387px;
            height: 220px;
            border-radius: 6px 6px 0 0;
          }
        }
        .bottom {
          padding: 20px;
          .title {
            font-size: 20px;
            font-weight: 500;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #1f1f1f;
            width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .subtitle {
            padding-top: 12px;
            font-size: 16px;
            color: #989da3;
            font-family: PingFangSC-Regular, PingFang SC;
            width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .time {
            padding-top: 14px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .txt {
              font-size: 12px;
              font-weight: 400;
              color: #666;
            }
            .more {
              font-size: 14px;
              color: #2355ef;
              cursor: pointer;
            }
          }
        }
      }
      .item:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
</style>
